<template>
    <div class="sub-header-layout">
        <div class="sub-header-layout-container">

            <!-- Link Content - Shows first on mobile, inline on desktop/tablet -->
            <div class="link-content">
                <slot name="linkContent">
                    <!-- Default content or placeholder -->
                    <div class="link-placeholder">Link Content</div>
                </slot>
            </div>

            <!-- Main Content - Takes remaining space on desktop/tablet, full width on mobile -->
            <div class="simple-bar-main-content">
                <slot name="mainContent">
                    <!-- Default content or placeholder -->
                    <div class="main-placeholder">Main Content</div>
                </slot>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'SubHeaderLayout',
    data() {
        return {}
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style scoped>
.sub-header-layout {
    width: 100%;
}

.sub-header-layout-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
}

.link-content {
    width: 100%;
    flex-shrink: 0;
    /* Prevent shrinking */
    display: flex;
    justify-content: center;
    z-index: 1;
    /* Center content on mobile */
}

.simple-bar-main-content {
    width: 100%;
    flex-grow: 1;
    /* Take remaining space */
    display: flex;
    justify-content: center;
    align-items: center;
}

/* Tablet and Desktop (768px and above) */
@media screen and (min-width: 1024px) {
    .sub-header-layout-container {
        flex-direction: row-reverse;
        align-items: flex-start;
        height: 8rem;
        z-index: 9;
    }

    .link-content {
        width: auto;
        /* Width to fit content */
        flex-shrink: 0;
    }

    .simple-bar-main-content {
        flex-grow: 1;
        /* Take the rest of the available space */
    }
}

/* Desktop (1024px to 1399px) - Inline layout with left/right alignment */
@media screen and(max-width: 1399px) {
    .sub-header-layout-container {
        flex-direction: row-reverse;
        align-items: flex-start;
        height: 8rem;
    }

    .simple-bar-main-content {
        flex-grow: 1;
        justify-content: flex-start;
        /* Align content to left */
    }

    .link-content {
        width: auto;
        flex-shrink: 0;
        margin-left: auto;
        /* Align to right */
    }
}

/* Desktop (1400px and above) - Center simple-bar-main-content by screen width */
@media screen and (min-width: 1400px) {
    .sub-header-layout-container {
        position: relative;
        height: 8rem;
    }

    .simple-bar-main-content {
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
    }

    .link-content {
        position: relative;
        margin-left: auto;
        margin-right: 1rem;
    }
}

/* Optional: Placeholder styling for development */
.link-placeholder,
.main-placeholder {
    padding: 1rem;
    border: 2px dashed #ccc;
    border-radius: 4px;
    text-align: center;
    background-color: #f9f9f9;
    color: #666;
}

.link-placeholder {
    background-color: #e3f2fd;
}

.main-placeholder {
    background-color: #f3e5f5;
}
</style>
